import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import useInject from "~/hooks/useInject"
import theme from '~/style/theme'
import StepBottomButtons from '~/components/traffic-tickets/steps/StepBottomButtons'

const Layout = styled.div`
  background: #FFFFFF;
  border-radius: 5px;
  padding: 20px;
  display:flex;
  flex-direction:column;
  height: 450px;
  width: 588px;
  justify-content: flex-end;
  ${props => props.theme.media.smallDesktop`
    width: 100%;
    height: 500px;
  `}
`

const mapStore = store => ({
  trafficSubmission: store.trafficSubmission,
})

const BasicLoader = () => {
  const {trafficSubmission} = useInject(mapStore)
  return (
      <Layout>
        <StepBottomButtons currentStore={trafficSubmission} />
      </Layout>
    )
  }

BasicLoader.defaultProps = {
  backgroundColor: theme.colors.background.main
}

BasicLoader.propTypes = {
  backgroundColor: PropTypes.string
}

export default BasicLoader
